export function useFaceDetector() {
  return {
    detectFaces: async () => [],
    stopListeners: () => undefined,
  };
}
